export default {
      id: "settings-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#settings",
      toString: function () {
        return this.url;
      }
    }